import VueCookies from 'vue-cookies'
import axios from 'axios'
import { Trans } from '@/plugins/Translations'

// state
export const state = {
  token: localStorage.getItem('token'),
  user: null,
  isUserLoading: false,
}

// getters
export const getters = {
  user: state => state.user,
  token: state => state.token,
  getUserCurrentAvatar: state => state.user && state.user.avatar,
  getUserCampaign: state => state.user && state.user.campaign,
  getNumberOfCompletedPredictions: state => state.user && state.user.predictions_count,
  getFriendsCount: state => state.user && state.user.friends_count,
  isUserEmailVerified: state => !!(state.user && state.user.email_verified_at),
}
// mutations
export const mutations = {
  authSuccess(state, token) {
    state.token = token
  },
  fetchUserStart(state) {
    state.isUserLoading = true
  },
  fetchUserSuccess(state, { user }) {
    if (user.language !== Trans.currentLanguage) {
      Trans.changeLanguage(user.language)
    }
    state.user = user
    state.isUserLoading = false
  },
  fetchUserFailed(state) {
    state.user = null
    state.token = null
    state.isUserLoading = false
  },
  logout(state) {
    state.user = null
    state.token = null
  },
  changeUserAvatar(state, { avatar }) {
    if (state.user) {
      state.user.avatar = avatar
    }
  },
  incrementPredictionCount(state) {
    if (state.user) {
      state.user.predictions_count++
    }
  },
  setUserCampaign(state, { campaign }) {
    if (state.user) {
      state.user.campaign = campaign
    }
  },
}
// actions
export const actions = {
  async storeToken({ commit, dispatch }, { token }) {
    localStorage.setItem('token', token)
    commit('authSuccess', token)
    dispatch('fetchUser')
  },
  async logout({ commit }) {
    commit('logout')
    localStorage.removeItem('token')
  },
  async fetchUser({ commit, dispatch }, { isSilent } = { isSilent: false }) {
    try {
      if (!isSilent) {
        commit('fetchUserStart')
      }
      let response = await axios.get('auth/check')
      commit('fetchUserSuccess', { user: response.user })
      dispatch('quests/quests/fetchQuests', false, { root: true })
      dispatch('qr/wechatInvite/fetchQrCode', false, { root: true })
      if (VueCookies.isKey('registration')) {
        dispatch('profile/howToPlay/openHowToPlayModal', false, { root: true })
        VueCookies.remove('registration')

        if (VueCookies.isKey('campaign')) {
          const campaign = VueCookies.get('campaign')
          dispatch('profile/myProfile/updateMyCampaign', { campaign }, { root: true })
          response.user.campaign = campaign
          VueCookies.remove('campaign')
        }
      }
      return response
    } catch (e) {
      commit('fetchUserFailed')
    }
  },
  incrementPredictionCount({ commit }) {
    commit('incrementPredictionCount')
  },
}
